import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { get, size } from 'lodash-es';
import { toast } from 'react-toastify';
import Table from '../../components/Table';
import Loading from '../../components/Loading';
import CollapseButton from '../../components/CollapseButton';
import { API_HOST } from '../../consts';

class PedidosTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: props.startCollapsed,
      fetchingElaboradores: true,
      elaboradores: [],
      entregas: [],
      data: {}
    };
  }

  componentDidMount() {
    const { collapsed } = this.state;
    if (!collapsed) {
      this.fetchElaboradores();
    }
  }

  componentDidUpdate(_, prevState) {
    const { collapsed } = this.state;
    if (prevState.collapsed && !collapsed) {
      this.fetchElaboradores();
    }
  }

  get columns() {
    const { handleVerMais } = this.props;
    const statuses = get(this.state, 'data.statuses', []);
    return [
      {
        Header: 'Adicionar Item',
        width: 125,
        filterable: false,
        Cell: (row) => (
          <div className="d-flex justify-content-center w-100">
            <button
              onClick={() => this.handleNovoItem(row)}
              className="btn primary-button"
            >
              <i className="fas fa-plus" /> Novo Item
            </button>
          </div>
        )
      },
      {
        Header: 'Nome',
        accessor: 'nome'
      },
      {
        Header: 'Dificuldade',
        accessor: 'dificuldade'
      },
      {
        Header: 'Tipo',
        accessor: 'tipo',
        width: 100
      },
      {
        Header: 'Solicitados',
        accessor: 'quantidade'
      },
      ...statuses.map((status) => ({
        Header: status.descricao,
        accessor: `statuses.${status.id}`,
        Cell: (row) => row.value || 0
      })),
      {
        Header: 'Ações',
        filterable: false,
        Cell: (row) => (
          <button onClick={() => handleVerMais(row)} className="btn btn-white">
            <i className="fas fa-eye" />
          </button>
        )
      }
    ];
  }

  get pageSize() {
    const length = get(this.state, 'data.elaboradores.length');
    const maxPageSize = 20;
    return length > maxPageSize ? maxPageSize : length;
  }

  get itensSolicitados() {
    const elaboradores = get(this.state, 'data.elaboradores', []);
    return elaboradores.reduce((acc, el) => acc + el.quantidade || 0, 0);
  }

  get itensEntregues() {
    const elaboradores = get(this.state, 'data.elaboradores', []);
    return elaboradores.reduce(this.reduceItensEntregues, 0);
  }

  reduceItensEntregues(acc, el) {
    const statuses = { ...get(el, 'statuses', {}) };
    delete statuses[1];
    return (
      acc + Object.values(statuses).reduce((acc2, value) => acc2 + value, 0)
    );
  }

  fetchElaboradores() {
    const { pedido } = this.props;
    axios
      .get(`${API_HOST}/encomenda/itens_por_status/elaborador`, {
        params: {
          pedido: get(pedido, 'id')
        }
      })
      .then((response) => {
        this.setState({ data: response.data, fetchingElaboradores: false });
      });

    this.fetchItensVinculados();
  }

  fetchItensVinculados() {
    const { pedido, getItensVinculados } = this.props;
    axios
      .get(`${API_HOST}/encomenda/item`, { params: { pedido: pedido.id } })
      .then((response) => {
        const itensVinculados = response.data.map((d) => d.id);
        getItensVinculados(itensVinculados);
      });
  }

  handleCollapse = () => {
    const { collapsed } = this.state;
    this.setState({ collapsed: !collapsed });
  };

  handleNovoItem = (row) => {
    const { history, pedido } = this.props;
    this.setState({ handlingNovoItem: true });
    axios
      .post(`${API_HOST}/encomenda/pedido/${pedido.id}/item`, {
        dificuldade: row.original.dificuldade_id,
        tipo: row.original.tipo_id
      })
      .then((response) => {
        const params = {
          vincular: true,
          encomendas: [row.original.encomenda]
        };
        axios.post(
          `${API_HOST}/encomenda/finalizar_item/${response.data.id}`,
          params
        );
        history.push(`/itens/${response.data.id}/dados`);
        this.setState({ handlingNovoItem: false });
      })
      .catch((error) => {
        if (get(error, 'response.status') === 403) {
          toast.error(get(error, 'response.data.detail'));
        } else {
          toast.error('Erro ao criar novo item.');
        }
        this.setState({ handlingNovoItem: false });
      });
  };

  render() {
    const { data, fetchingElaboradores, collapsed } = this.state;
    const { elaboradores } = data;
    const { pedido, handleVincularItens, labelCompetencia, labelHabilidade } =
      this.props;

    return (
      <Fragment key={get(pedido, 'id')}>
        {/* <Itens /> */}
        <div className="container">
          <div className="professores-first">
            <div className="row">
              <div className="col-3">
                <p className="subtitle">Matriz de Referência</p>
                <p>{get(pedido, 'matriz_referencia.nome') || '-'}</p>
              </div>
              <div className="col-4">
                <p className="subtitle">{labelCompetencia}</p>
                <p>{get(pedido, 'competencia.descricao') || '-'}</p>
              </div>
              <div className="col-4">
                <p className="subtitle">{labelHabilidade}</p>
                <p>{get(pedido, 'habilidade.descricao') || '-'}</p>
              </div>
              <div className="col-1">
                <CollapseButton
                  collapsed={collapsed}
                  onClick={this.handleCollapse}
                />
              </div>
            </div>
            {!collapsed && fetchingElaboradores && <Loading />}
            {!collapsed && !fetchingElaboradores && (
              <Fragment>
                <hr />
                <div className="row align-items-center">
                  <div className="col-md-6 col-lg-5 mb-3">
                    <button
                      className="btn primary-button"
                      onClick={handleVincularItens}
                    >
                      <i className="fas fa-link mr-2" />
                      VINCULAR ITENS
                    </button>
                  </div>
                  <div className="col-md-3 col-lg-2 offset-lg-3 mb-3">
                    <p className="subtitle">Itens Solicitados:</p>
                    <p>{this.itensSolicitados}</p>
                  </div>
                  <div className="col-md-3 col-lg-2 mb-3">
                    <p className="subtitle">Itens Entregues:</p>
                    <p>{this.itensEntregues}</p>
                  </div>
                  <div className="col-12">
                    <Table
                      showPageSizeOptions={false}
                      showPagination={size(elaboradores) > this.pageSize}
                      pageSize={this.pageSize}
                      minRows={size(elaboradores)}
                      filterable
                      data={elaboradores || []}
                      columns={this.columns}
                      className="table-default pedidos-table"
                    />
                  </div>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

PedidosTab.propTypes = {
  pedido: PropTypes.shape({
    id: PropTypes.number
  }).isRequired,
  startCollapsed: PropTypes.bool,
  handleVincularItens: PropTypes.func.isRequired,
  handleVerMais: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

PedidosTab.defaultProps = {
  startCollapsed: true
};

export default withRouter(PedidosTab);
